import { useMemo } from 'react';
import { ApprovalActorRole } from 'ui-product-approvals-common';
import { ACTOR } from '../constants/actors';
export const useCurrentActorRole = (approvalData, currentUser) => useMemo(() => {
  var _currentUser$user_id;
  // Not yet updated to support TEAM actors — only USER actors are matched
  // here. Agent actors aren't relevant here as they don't perform actions on the FE.
  let result = ApprovalActorRole.NON_PARTICIPANT;
  if (!approvalData) {
    return result;
  }
  if (approvalData.requester.actor.actorType === ACTOR.USER && approvalData.requester.actor.id === (currentUser === null || currentUser === void 0 || (_currentUser$user_id = currentUser.user_id) === null || _currentUser$user_id === void 0 ? void 0 : _currentUser$user_id.toString())) {
    result = ApprovalActorRole.REQUESTER;
  } else if (approvalData.approvalSteps.length && approvalData.approvalSteps.some(approvalStep => {
    var _currentUser$user_id2;
    return approvalStep.approver.actor.actorType === ACTOR.USER && approvalStep.approver.actor.id === (currentUser === null || currentUser === void 0 || (_currentUser$user_id2 = currentUser.user_id) === null || _currentUser$user_id2 === void 0 ? void 0 : _currentUser$user_id2.toString());
  })) {
    result = ApprovalActorRole.APPROVER;
  }
  return result;
}, [approvalData, currentUser]);